import styled from 'styled-components';
import { ArrowIosForward } from '@styled-icons/evaicons-solid/ArrowIosForward';

export const Wrapper = styled.div`
  height: 30%;
  margin: 6rem 0;

  img {
    position: absolute;
    top: -19px;
    left: 12%;
    z-index: -1;
    opacity: 0.8;
    width: 13%;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  height: 90px;
  width: 1320px;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  border-radius: 60px;
  background: #0f1423;
  box-shadow: 9px 9px 18px #0b0e19, -9px -9px 18px #131a2d;
`;

export const Title = styled.h1`
  font-size: 119px;
  color: #fff;
  font-weight: 700;\
  z-index: 10;
  position: relative;
  text-shadow: 7px 11px 6px #10152552;
`;
export const Text = styled.p`
  font-size: 18px;
  color: #fff;
  font-weight: 400;
  z-index: 10;
  position: relative;
  text-shadow: 7px 11px 6px #10152552;
  width: 70%;
  margin: 1rem auto 3rem;
`;

export const ErrorMsgLink = styled.h5`
  font-size: 15px;
  color: #fd7e00;
  font-weight: 600;
  z-index: 10;
  position: absolute;
  left: 35px;
  bottom: -70%;
`;

export const ErrorMsgName = styled(ErrorMsgLink)`
  font-size: 15px;
  color: #fd7e00;
  font-weight: 600;
  z-index: 10;
  position: absolute;
  right: -85px;
  bottom: -70%;
`;

export const Form = styled.form`
  // border: 1px solid #f00;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
`;

export const Input = styled.input`
  color: ${(props) => props.inputColor || 'palevioletred'};
  padding: 1.5em;
  margin: 10px 10px;
  box-sizing: border-box;
  color: black;
  background: #fff0;
  border: none;
  border-radius: 3px;
  width: 50%;
  height: 100%;
  color: #fff;
  font-weight: 500;
  font-size: 19px;
  font-family: 'Quicksand', sans-serif;
  // border-right: 5px solid #111729;

  .right-input {
    border-right: none !important;
  }
  :focus {
    outline: none;
  }

  input:-webkit-autofill {
    -webkit-animation-delay: 1s; /* Safari support - any positive time runs instantly */
    -webkit-animation-name: autofill;
    -webkit-animation-fill-mode: both;
  }

  @-webkit-keyframes autofill {
    0%,
    100% {
      color: #666;
      background: transparent;
    }
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active,
  &:-internal-autofill-selected {
    background-color: black !important;
    color: #fff !important;
  }

  ::placeholder {
    color: #434b64;
    font-weight: 600;
    font-size: 17px;
    font-family: 'Quicksand', sans-serif;
  }
`;
export const InputRight = styled(Input)`
  border-right: none !important;
  width: 40%;
`;

export const Submit = styled.button`
  padding: 0.5em;
  box-sizing: border-box;
  font-weight: 500;
  font-size: 19px;
  font-family: 'Quicksand', sans-serif;
  border: none;
  border-radius: 10px 100px 100px 10px;
  width: 6%;
  height: 100%;
  position: relative;
  right: 10px;
  top: 0;
  cursor: pointer;
  // box-shadow: -6px 0px 10px #26262600, inset 0 0 10px #151c2e59;
  background: #ef6509;
  -webkit-transition: 0.2s;
  transition: 0.3s;
  background: linear-gradient(to right, #f83600, #fe8c00);

  i {
    z-index: 99999;
    font-size: 42px;
    color: #0f1423;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 78%;
    left: 46%;
    display: block;
    transform: translate(-50%, -50%);
  }
  &:hover {
    transform: translateX(3px);
    transition: 0.3s;
  }
  :focus {
    outline: none;
  }
`;
export const AddIcon = styled(ArrowIosForward)`
  color: black;
  height: 45px;
  width: 45px;
  // position: absolute;
  right: 12px;
  // top: 10px;
  cursor: pointer;
  transition: 0.2s all;
`;
